import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import { TypingIndicatorStyles } from "./TypingIndicator.styles";
export var TypingIndicator = function () {
    var sx = TypingIndicatorStyles();
    return (_jsxs(Box, { sx: sx.wrapper, children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {})] }));
};
